import { Plus } from "@phosphor-icons/react";
import {
  Button,
  Dialog,
  Flex,
  TextField,
  Text,
  Grid,
  VisuallyHidden,
} from "@radix-ui/themes";
import { useRouter } from "@tanstack/react-router";

import { useCreateFolderMutation } from "../../utils/queries/projects";
import { queryClient } from "../../utils/queryClient";

type CreateFolderDialogProps = {
  // TODO: abstract these attributes to a more global type
  open: boolean;
  onOpenChange(open: boolean): void;
  // attributes specific to this component
  folderId?: string;
};

export function CreateFolderDialog(props: CreateFolderDialogProps) {
  const { folderId, open, onOpenChange } = props;

  const router = useRouter();
  const createFolderMutation = useCreateFolderMutation();

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="332px" size="1">
        <Dialog.Title>New Folder</Dialog.Title>
        <VisuallyHidden>
          <Dialog.Description>
            Create a new folder to organize your workflows.
          </Dialog.Description>
        </VisuallyHidden>

        <form
          onSubmit={(e) => {
            e.preventDefault();

            const form = e.target;
            const formData = new FormData(form as HTMLFormElement);
            createFolderMutation.mutate(
              {
                folder: {
                  folderId,
                  name: formData.get("folder-name") as string,
                },
                tickets: [],
              },
              {
                onSuccess() {
                  queryClient.invalidateQueries({
                    queryKey: ["folders", "tree"],
                  });
                  router.invalidate();
                  onOpenChange(false);
                },
              },
            );
          }}
          className="grid gap-4"
        >
          <Grid gap="2">
            <Text size="2" weight="medium">
              Folder Name
            </Text>
            <TextField.Root
              required
              variant="classic"
              size="2"
              placeholder="Folder Name"
              name="folder-name"
            />
          </Grid>

          <Flex gap="2" align="center" justify="end">
            <Dialog.Close>
              <Button
                variant="soft"
                color="gray"
                disabled={createFolderMutation.isPending}
              >
                Cancel
              </Button>
            </Dialog.Close>

            <Button
              type="submit"
              disabled={createFolderMutation.isPending}
              loading={createFolderMutation.isPending}
            >
              <Plus />
              Create Folder
            </Button>
          </Flex>
        </form>
      </Dialog.Content>
    </Dialog.Root>
  );
}
